// extracted by mini-css-extract-plugin
export default {"wrapper":"_1oONtm_n","pageHeader":"_1DOpPPNV","pageTitle":"_1qJOLi4a","pageDescription":"_2BCgmMls"};